import { render, staticRenderFns } from "./DetalhesProduto.vue?vue&type=template&id=1d0369b3&scoped=true"
import script from "./DetalhesProduto.vue?vue&type=script&lang=js"
export * from "./DetalhesProduto.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProduto.vue?vue&type=style&index=0&id=1d0369b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0369b3",
  null
  
)

export default component.exports